export default class Connections {
    initialize() {
        this.withdrawModalMessage();
    }

    withdrawModalMessage() {
        var withdraw_messages = $('.withdraw-modal-message');

        if (withdraw_messages.length) {
            // Get the universal select options
            var select_options = [];
            $('.withdraw-modal-select')
                .first()
                .find('option')
                .each(function () {
                    if ($(this).val() != '') {
                        select_options.push($(this).val());
                    }
                });

            // On message changes check whether to update the select
            withdraw_messages.keyup(function (e) {
                var this_message = $(this);
                var this_select = $(`.${this_message.attr('data-select-id')}`);

                if ($.inArray(this_message.val(), select_options) !== -1) {
                    // Set the select to match
                    this_select.val(this_message.val());
                } else {
                    // Clear the select
                    this_select.val('');
                }
            });
        }
    }
}
